var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-menu',{attrs:{"md-direction":"bottom-end","md-align-trigger":"","md-close-on-click":""}},[_c('md-button',{staticClass:"md-just-icon md-primary",attrs:{"md-menu-trigger":""}},[_c('md-icon',[_vm._v(" more_horiz")])],1),_c('md-menu-content',[_c('li',[_c('a',{on:{"click":_vm.actionRestore}},[_vm._v("Restore")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }